import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

/**
 * Field-app surface gate (HCP#1686).
 * Console roles must not soft-open FieldSurveyor routes; seeded denied-route
 * probes require redirect off those paths while staying authenticated.
 */
export function FieldSurveyorOnly({ children }: { children: ReactNode }) {
  const { viewerContext, isLoading } = useAuth()
  if (isLoading) return null
  if (viewerContext && viewerContext.role !== 'FieldSurveyor') {
    return <Navigate to="/dashboard" replace />
  }
  return <>{children}</>
}
